import React from 'react';

import formatTime from './../../utils/formatTime';
import Icon from './../Icon';

const FinalPaperFileRow = props => {
    const { file, onRemove, plagFileHref, isModal, isError } = props;
    if (!file.isFetching) {
        return (
            <div className="row upload-file-item">
                <div className="col-4">
                    {!!plagFileHref &&
                        <Icon className="svg-icon" iconName="plagreport" />
                    }
                    <a className href={file.location} target="_blank" rel="noopener noreferrer"><span>{file.name}</span></a>
                    {!!onRemove && file.owner_role === 'grader' &&
                        <button className="btn btn-empty btn-delete-file" type="button" onClick={() => onRemove(file._id)} disabled={file.isFetchingRemove}>
                            <svg className="delete-file">
                                <g>
                                    <circle cx="8" cy="8" r="8" />
                                    <path fill="#9CA9B5" fillRule="nonzero" d="M8.667 8L11 5.667 10.333 5 8 7.333 5.667 5 5 5.667 7.333 8 5 10.333l.667.667L8 8.667 10.333 11l.667-.667L8.667 8z" />
                                </g>
                            </svg>
                        </button>
                    }
                </div>
                {!!plagFileHref &&
                    <div className="col-2 ta-right"><a href={plagFileHref} target="_blank" rel="noopener noreferrer" className="badge plag-report">Plag report</a></div>
                }
                <div className={plagFileHref ? 'col-4 ta-right order-file-date' : 'col-2 ta-right order-file-date'}>
                    {file.owner_role} on {formatTime(file.created_at, 'dt')}
                </div>
            </div>
        );
    }
    if (isModal) {
        return (
            <div>
                <div className="row vertical modal-file-item">
                    <div className="col-file-name">
                        <span className="upload-file-progress">
                            <i className="file-name-progress">{file.name}</i>
                        </span>
                    </div>
                    {!isError &&
                        <div className="row vertical">
                            <div className="file-upload-info">
                                <div className="file-progress">
                                    <i className="bg-progress" style={{ width: file.progress + '%' }}></i>
                                </div>
                                <span className="file-progress-percent"><b>{file.progress}</b> %</span>
                            </div>
                            <div className="col-2">
                                <a onClick={(e) => { e.stopPropagation(); onRemove(file._id) }}>Cancel</a>
                            </div>
                        </div>
                    }
                    {isError &&
                        <div className="row vertical space-between">
                            <div className="text-danger file-upload-info">uploading error</div>
                            <a onClick={(e) => { e.stopPropagation(); onRemove(file._id) }}>Close</a>
                        </div>
                    }

                </div>
            </div>
        );
    }
    return (
        <div className="row">
            <div className="col-1">
                <span className="upload-file-progress">
                    <i className="file-name-progress">{file.name}</i>
                    <i className="bg-progress" style={{ width: file.progress + '%' }}></i>
                </span>
            </div>
        </div>
    );
};

export default FinalPaperFileRow;


// WEBPACK FOOTER //
// ./src/components/order/FinalPaperFileRow.js